<template>
  <div class="news-item-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="sides-padding">
      <div class="container container--small">
        <h1 class="news-item-page__title">{{ news_item.title }}</h1>
      </div>
    </div>
    <div class="news-item-page__container sides-padding">
      <div class="news-item-page__content">
        <div class="container container--medium">
          <ImgComponent class="news-item-page__img" :head_img="news_item.head_img" quality="100" />
        </div>
        <div
          v-if="$options.filters.editor_has_text(news_item.description)"
          class="container container--small"
        >
          <EditorJSComponent :text="news_item.description" />
        </div>
        <ShareNetworksComponent :data="news_item" />
      </div>
    </div>
    <div class="news-item-page__also sides-padding">
      <div class="container">
        <h2 class="title">Читайте также</h2>
        <div class="news-item-page__also-list">
          <EntityCardComponent
            v-for="(item, i) in read_also_news.data"
            :key="i"
            :item="item"
            :is-news="true"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NEWS_ITEM_PAGE from "@/graphql/pages/NewsItemPage.graphql";
import EditorJSComponent from "components/EditorJSComponent.vue";
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import ShareNetworksComponent from "components/ShareNetworksComponent.vue";
import EntityCardComponent from "components/EntityCardComponent.vue";

export default {
  name: "NewsPagePage",
  async asyncData({ apollo, store, route }) {
    await apollo.defaultClient
      .query({
        query: NEWS_ITEM_PAGE,
        variables: {
          id: parseInt(route.params.id),
        },
      })
      .then(({ data }) => {
        store.state.news_item_page.news_item = data.news_item;
        store.state.news_item_page.read_also_news = data.news_paginate;
        store.state.all_brands = data.brands || [];
        store.state.popular_brands = data.brands_paginate.data || [];
        store.state.categories = data.header_categories.data || [];
        store.state.pages = data.pages;
        store.state.marketplace = data.marketplace;
      });
  },
  computed: {
    links() {
      return [{ title: "Блог" }];
    },
    news_item() {
      return this.$store.state.news_item_page.news_item;
    },
    read_also_news() {
      return this.$store.state.news_item_page.read_also_news;
    },
  },
  components: {
    EntityCardComponent,
    ShareNetworksComponent,
    BreadcrumbsComponent,
    EditorJSComponent,
  },
  metaInfo() {
    return {
      title: this.news_item.meta_title || this.news_item.title,
      description: this.news_item.meta_description,
      keywords: this.news_item.meta_keywords,
      meta: [
        {
          vmid: "og:image",
          name: "og:image",
          content: this.news_item.head_img
            ? this.$store.state._env.MEDIA_ENDPOINT + this.news_item.head_img.path
            : null,
        },
      ],
    };
  },
};
</script>

<style lang="stylus">
.news-item-page {
  width 100%
  display grid
  grid-gap 50px
  padding-top 32px
  padding-bottom 48px
  +below(480px) {
    grid-gap 30px
  }
  +below(420px) {
    grid-gap 16px
  }

  &__title {
    font-weight: normal;
    display: flex;
    align-items: center;
    color: var(--body-color);
    margin 0 auto
    text-align left
  }

  &__container {
    display: flex;
    justify-content: center;
  }

  &__content {
    display grid
    grid-gap 32px
    width 100%
    max-width var(--main_width)
  }

  &__img {
    width 100%
    height 100%
    max-height 700px
    object-fit cover
    object-position center
    border-radius var(--main_radius)
  }

  &__also {
    padding-top 50px
    border-top 1px solid var(--main-color-75)

    .title {
      margin-bottom 30px
    }

    &-list {
      display: flex;
      gap: 30px;
      overflow auto
      padding-bottom 5px

      .entity__item {
        min-width 350px
        +below(480px) {
          min-width 300px
        }
      }
    }
  }
}
</style>
